import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SezioneTitoli } from '../../../models/sezioni/sezione-titoli';
import { TitoloAddFormComponent } from './titolo-add-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [modale_aggiungi_titolo]',
  templateUrl: 'titolo-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class TitoloModAddComponent {
  @Output() onReturn: EventEmitter<SezioneTitoli> = new EventEmitter<SezioneTitoli>();
  @ViewChild('formTitolo') formTitolo: TitoloAddFormComponent;

  inizializza(urlAddTitolo: string, idSezione: string, idFascicolo: string) {
    openModal('modaleAddTitolo');
    this.formTitolo.inizializza(urlAddTitolo, idSezione, idFascicolo);

  }

  createForm() {
    this.formTitolo.createForm();
  }

  manageModal(sezione: SezioneTitoli) {
    if (sezione) {
      closeModal('modaleAddTitolo');
      this.onReturn.emit(sezione);
    }
  }
}
